/**
 * Copyright (c) 2021 - 2023, Kodit Doo
 * Created by kodit-marko on 21.02.2023.
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'kodit-unos-broja-option',
  templateUrl: './unos-broja-option.html',
  styleUrls: ['./unos-broja-option.scss'],
})
export class UnosBrojaOptionComponent implements OnInit {
  /** Subs */

  /** Props */
  value: UnosBrojaOption;
  options: SelectItem[];

  /** I/O */
  @Input() defaultValue: UnosBrojaOption = UnosBrojaOption.AUTOMATSKI;
  @Input() label: string;
  @Output() valueChanged = new EventEmitter<UnosBrojaOption>();

  constructor() {
    this.value = this.defaultValue;
    this.options = [
      { label: 'Automatski', value: UnosBrojaOption.AUTOMATSKI },
      { label: 'Ručno', value: UnosBrojaOption.MANUELNO },
    ];
    this.label = 'Broj računa';
  }

  ngOnInit(): void {}

  handleValueChanged(value: UnosBrojaOption) {
    this.valueChanged.emit(value);
  }
}

export enum UnosBrojaOption {
  AUTOMATSKI = 0,
  MANUELNO = 1,
}
